import { useRoot } from "../../contexts/Root";
import { useMarkers } from "../../contexts/Markers";
import { Edge } from "../../types/edge";

import styles from "./EdgeLabel.module.css";
import { CSSProperties } from "react";
import { useRange } from "../../contexts/Range";
import { useVideoSource } from "../../contexts/VideoSource";

interface Props {
  edge: Edge;
}

export const EdgeLabel = ({ edge }: Props) => {
  const { range } = useRange();
  const { duration } = useVideoSource();
  const {
    theme: { foreground },
  } = useRoot();

  const { markers } = useMarkers();

  const critical =
    (range !== undefined && (edge === Edge.start ? range.start : range.end)) ||
    (edge === Edge.start ? 0 : duration);

  const reversedMarkers = [...markers].reverse();

  const marker =
    reversedMarkers.find((marker) => marker.time <= critical) ?? markers[0];

  const style = {
    color: foreground,
    justifyContent: edge === Edge.start ? "flex-start" : "flex-end",
  } as CSSProperties;

  return (
    <div className={styles.container} style={style}>
      {marker?.label}
    </div>
  );
};
